import { api } from "./client";

export interface Mkb10Read {
  code: string;
  description_ru: string;
  description_uz: string | null;
  description_en: string | null;
  parent_code: string | null;
  is_billable: boolean;
}

export interface Mkb10CreatePayload {
  code: string;
  description_ru: string;
  description_uz?: string | null;
  description_en?: string | null;
  parent_code?: string | null;
  is_billable?: boolean;
}

export interface Mkb10UpdatePayload {
  description_ru?: string;
  description_uz?: string | null;
  description_en?: string | null;
  parent_code?: string | null;
  is_billable?: boolean;
}

export async function searchMkb10(
  q: string,
  limit = 20,
  offset = 0,
): Promise<{ items: Mkb10Read[]; total: number }> {
  const { data } = await api.get<{ items: Mkb10Read[]; total: number }>(
    "/references/mkb10",
    { params: { q: q || undefined, limit, offset } },
  );
  return data;
}

export async function createMkb10(payload: Mkb10CreatePayload): Promise<Mkb10Read> {
  const { data } = await api.post<Mkb10Read>("/references/mkb10", payload);
  return data;
}

export async function updateMkb10(code: string, payload: Mkb10UpdatePayload): Promise<Mkb10Read> {
  const { data } = await api.patch<Mkb10Read>(`/references/mkb10/${encodeURIComponent(code)}`, payload);
  return data;
}

export async function deleteMkb10(code: string): Promise<void> {
  await api.delete(`/references/mkb10/${encodeURIComponent(code)}`);
}
